// Display ETH-denominated amounts as USD for the igaming-demo route.
// 1 ETH unit in SETTINGS = $1000 (so 0.001 → $1, 0.01 → $10, 0.1 → $100).
const USD_PER_ETH = 1000;

const fmt = (usd: number, decimals: number) =>
  `$${usd.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;

export const ethStringToUsd = (eth: string | number) => {
  const v = typeof eth === 'string' ? parseFloat(eth) : eth;
  if (!isFinite(v)) return 0;
  return v * USD_PER_ETH;
};

export const formatUsdFromEth = (eth: string | number) => {
  const usd = ethStringToUsd(eth);
  return fmt(usd, usd >= 1 ? 0 : 2);
};

export const formatUsdFromWei = (wei: bigint, ethDecimals = 18, decimals = 2) => {
  const eth = Number(wei) / 10 ** ethDecimals;
  const usd = eth * USD_PER_ETH;
  return fmt(usd, decimals);
};
